.illustration-container {
    display: flex;
    justify-content: center;
    background-color: var(--blue-bg-lt);
    padding-left: 32px;
    padding-right: 32px;
    padding-top: 48px;
    padding-bottom: 48px;
}

/* Modal uses fitHeight, need to have the loading container have a fixed height so it doesn't get collapsed */
.loading-container {
    height: 700px;
}
